import React from 'react';
import { Dropdown } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import DeleteActionModal from './deleteActionModal';
import PropTypes from 'prop-types';

export function DeleteAction({ objects: selectedRates, model, rates, disabled = false, onClick = () => {}, onSave, withModal = true }) {
    const [showModal, setShowModal] = React.useState(false);
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {withModal && showModal && (
                <DeleteActionModal objectsToDelete={selectedRates} showModal={showModal} model={model} rates={rates} onSave={onSave} onClose={() => setShowModal(false)} />
            )}
            <Dropdown.Item
                disabled={disabled}
                onClick={() => {
                    onClick();
                    setShowModal(true);
                }}
                deleteItem
            >
                {t('ticket.common.action.delete')}
            </Dropdown.Item>
        </React.Fragment>
    );
}

DeleteAction.propTypes = {
    objects: PropTypes.array, //required
    rates: PropTypes.array.isRequired,
    model: PropTypes.func,
    disabled: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onClick: PropTypes.func
};
